import { AddBox } from "@mui/icons-material";
import { Button, Dialog, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import { SEND_INBOX } from "../../../enums/PermissionTitles";
import { useFetch } from "../../../hooks/Fetching";
import useUser from "../../../hooks/useUser";
import { useIsMobile } from "../../../utils/Functions";
import NewConversation from "../form/NewConversation";
import { useTranslation } from "react-i18next";
import { RECIPIENTS_LIST_FETCH } from "../../../enums/ApiPaths";

export const receiver = "receiver";
export const receiver_ids = "receiver_ids";

export default function OpenConversation({ profileId, buttonTitle = null, icon = <AddBox />}) {
  const [open, setOpen] = useState(false);
  const {t} = useTranslation();
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const { roles } = useUser();
  const hasPermision = isPermissionAllowed(SEND_INBOX);
  const [searchParams, setSearchParams] = useSearchParams();
  const enableRecipientFetching = open && hasPermision && !roles.user;
  const {
    data: users = [],
    isLoading,
    error,
  } = useFetch(
    RECIPIENTS_LIST_FETCH,
    null,
    "recipients" + profileId,
    enableRecipientFetching
  );
  
  const fullScreen = useIsMobile();

  const handleClickOpen = () => setOpen(true);
  
  const handleClose = () => {
    setOpen(false);
    searchParams.delete(receiver);
    searchParams.delete(receiver_ids);
    setSearchParams(searchParams);
  };

  if (roles.user || !hasPermision) {
    return null;
  }

  return (
    <>
      {buttonTitle ? 
        <Button variant="outlined" onClick={handleClickOpen}>
          {t(buttonTitle)}
        </Button> :
        <IconButton color="info" onClick={handleClickOpen} title={t("OpenConversation")}>
          {icon}
        </IconButton>
      }
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        fullScreen={fullScreen}
      >
        <NewConversation
          error={error}
          isLoading={isLoading}
          users={users}
          profileId={profileId}
          handleClose={() => handleClose()}
        />
      </Dialog>
    </>
  );
}
